export default "__VITE_ASSET__lE$fAJ6U__"